//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {zipObjectDeep} from 'lodash'
import moment from 'moment'
export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  data() {
      return {
          searched: false,
          formData: {},
          errors: [],
          locations: []
      }
  },
async mounted () {
    const fields = this.blok.form_fields.map((f ) =>{
     return [f.id]
    })  
    this.formData =  zipObjectDeep(fields, this.emtpyData)
  }, 

 methods: {
   resetForm(){
      this.errors = []
      const fields = this.blok.form_fields.map((f ) =>{
          return [f.id]
       })  
      this.formData =  zipObjectDeep(fields, this.emtpyData)
   },
    async handleBlur(e) {
      if(e == 'zipcode') {
        this.$store.commit('setFaveLocationLoyalty', false)
        this.$store.commit('setLoading', true)
        let locations = await this.$api.findMemberLocations({ zip: this.formData[e]})
        this.searched = true
        this.$store.commit('setLoading', false)
        if(locations && locations.count > 0) {
          let locs = []
          locations.locations.map(l => {
            locs.push({
              value: l.sid,
              name: `${l.address}, ${l.city}, ${l.state}`
            })
          })
          this.locations = locs
        }
      }
    },
    async signup(e) {
       let data = {}
       let errors = []
       Object.keys(this.formData).map(f => {
         let v = this.formData[f]
         console.log(f, v)
         switch(f) {
            case 'firstName':
              if(v.match(/^[a-zA-Z]+/)) {
                data.first_name = v
              } else {
                errors.push({id:'firstName',message:'Please enter your first name.'})
              }
              break
            case 'lastName':
              if(v.match(/^[a-zA-Z]+/)) {
                data.last_name = v
              } else {
                errors.push({id:'lastName',message:'Please enter your last name.'})
              }
              break
            case 'email':
              if(v.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                data.email = v
              } else {
                errors.push({id:'email',message:'Please enter your email.'})
              }
              break
            case 'emailConfirm':
              if(v != this.formData.email) {
                errors.push({id:'emailConfirm', message:'Email addresses do not match.'})
              }
              break
            case 'password':
              if(v.length < 6) {
                errors.push({id:'password', message:'Your password must be 6 characters or longer'})
              } else if (!/[A-Z]/.test(v)) {
                errors.push({id:'password', message:'Your password must contain at least 1 uppercase character'})
              } else if (!/\d/.test(v)) {
                errors.push({id:'password', message:'Your password must contain at least 1 number'})
              // } else if (!/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(v)) {
              //   errors.push({id:'password', message:'Your password must contain at least 1 special character'})
              } else {
                data.password = v
              }
              break
            case 'passwordConfirm':
              if(v != this.formData.password) {
                errors.push({id:'passwordConfirm', message:'Passwords do not match.'})
              }
              break
            case 'birthdate':
              if(moment(v, 'MMDDYYYY',true).isValid()) {
                data.dob = moment(v, 'MMDDYYYY').format('YYYY-MM-DD')
              } else {
                errors.push({id:'birthdate', message:'Please enter your birthdate in MM/DD/YYYY format.'})
              }
              break
            case 'zipcode':
              if(v.match(/\d{5}/) || (v.match(/\w{6}/))) {
                data.zip = v
              } else {
                errors.push({id:'zipcode', message:'Please enter your zipcode.'})
              }
              break
            case 'perferredStore':
              console.log(f, v)
              if(v && v.toString().match(/\d{3,6}/)) {
                console.log(v)
                data.favelocation = v
              } else {
                errors.push({id:'preferredStore', message:'Please select a preferred store.'})
              }
              break
         }
       })
      data.optin = this.formData.emailUpdates || false
      if(this.formData.agreeToTerms != true) {
        errors.push({id:'agreeToTerms', message:'To move forward you will need to agree to our terms and privacy policy.'})
      }

      if (this.$store.state.faveLocationLoyalty === true && this.formData.vipPerks === true) {
        data.loyalty = true
        data.optin = true
      } else {
        data.loyalty = false
      }

      // if(this.$store.state.faveLocationLoyalty === true && this.$store.state.loyaltySignupOptIn === true) {
        if (this.formData.phone && this.formData.phone.match(/^\d{10}$/)) {
          data.phone = this.formData.phone
        } else {
          errors.push({id:'phone', message: 'Please enter a valid 10 digit phone number. (digits only)'})
        }
      // }

      console.log(data)

      this.errors = errors
      console.log(errors)
      if(errors.length < 1) {
        this.$store.commit('setLoading', true)
        let create = await this.$api.memberSignup(data)
        if(create) {
          let userData = await this.$api.memberSignin(data.email, data.password)
          if(userData) {
            this.$store.commit('setUserToken', userData.tokens)
            let user = await this.$api.getMemberProfile()
            this.$store.commit('setActiveUser', user)
            let location = await this.$api.getLocation(data.favelocation)
            let fave = await this.$api.setFaveLocation(location.menu_id)
              if(fave) {
              let user = JSON.parse(JSON.stringify(this.$store.state.activeUser))
              if(user.favelocations) {
                user.favelocations = [fave.favelocations[0]]
              } else {
                user.favelocations.push(fave.favelocations[0])
              }
              this.$store.commit('setActiveUser', user)
            }
            if(this.$store.state.redirect) {
              let redirect = this.$store.state.redirect
              this.$store.commit('setRedirect', null)
              this.$router.push(redirect)
            } else {
              this.$router.push('/account')
            }
          }
        } else {
          // console.log('Sign Up Fail: User probably already exists, check network tab for exact details')
          // API error, probably the user already exists
        }
        this.$store.commit('setLoading', false)
      }
    }
 },
computed: {
  loyalty() {
    return this.$store.state.faveLocationLoyalty
  },
  emtpyData() {
    return this.blok.form_fields.map(() => {
      return ''
    })
  },
  fsc() {
    return this.blok.form_fields.map((f ) =>   f.id )  
  },
},
}
